(function($) {

    $('#editions-selection .dropdown-item').off('click').on('click', function (e) {

        e.preventDefault();

        var _edition = $(this).data('edition');
        $('#editions-selection .dropdown-item').removeClass('active');
        $('#editions-selection .dropdown-item[data-edition='+_edition+']').addClass('active');
        $('#editions-selection #dropdownEditions').text($('#editions-selection .dropdown-item[data-edition='+_edition+']').html());

        // Display links for selected edition
        var _platforms = _final_retailers_list[_edition]['platforms'];

        Object.entries(_platforms).forEach(([platform, link]) => {
                $('#platforms .btn-platform[data-platform='+ platform +']').attr('href', link);
        });

        setTimeout(function() { $('#platforms .btn-platform').removeClass('disabled'); }, 200);

    });

    $('#editions .edition').off('click').on('click', function (e) {
        e.preventDefault();
        var _edition = $(this).data('edition');

        $('#editions-selection .dropdown-item').removeClass('active');
        $('#editions-selection .dropdown-item[data-edition='+_edition+']').addClass('active');
        $('#editions-selection #dropdownEditions').text($('#editions-selection .dropdown-item[data-edition='+_edition+']').html());

        // Display links for selected edition
        var _platforms = _final_retailers_list[_edition]['platforms'];

        Object.entries(_platforms).forEach(([platform, link]) => {
            $('#platforms .btn-platform[data-platform='+ platform +']').attr('href', link);
        });

        setTimeout(function() { $('#platforms .btn-platform').removeClass('disabled'); }, 200);

    });

})(jQuery);